const gcJcamp3 = `

##TITLE=Spectrum
##JCAMP-DX=5.00 $$ chemotion-converter-app (1.1.0)
##DATA TYPE=GAS CHROMATOGRAPHY
##DATA CLASS=NTUPLES
##$CSCATEGORY=SPECTRUM
##ORIGIN=
##OWNER=
##XUNITS=MINUTES
##YUNITS=DEGREES CELSIUS
##SOFTWARE=LabSolutions
##SOFTWARE_VERSION=5.110
##METHOD=D:\\Methods\\GC-BID_inc-5min-30_GC-3min-40-7min-180-2min_Calibrated.gcm
##DATE=14.11.2023
##TIME=12:48:40
##OPERATOR=System Administrator
##INSTRUMENT=ComPlat_GC-BID
##NAME1=H2
##RTIME1=2.887
##CONC_PPM1=24148.876
##CONC_QUOTA1=13.975
##NAME2=Ar / O2
##RTIME2=3.472
##CONC_PPM2=0.000
##CONC_QUOTA2=0.000
##NAME3=N2
##RTIME3=4.355
##CONC_PPM3=0.000
##CONC_QUOTA3=0.000
##NAME4=CH4
##RTIME4=0.000
##CONC_PPM4=0.000
##CONC_QUOTA4=0.000
##NAME5=CO
##RTIME5=6.682
##CONC_PPM5=148645.945
##CONC_QUOTA5=86.025
##FIRSTX=0.00055
##LASTX=11.98388
##MINX=0.00055
##MAXX=11.98388
##MINY=39.9
##MAXY=180.2
##NPOINTS=720
##FIRSTY=40.0
##XUNITS=MINUTES
##YUNITS=DEGREES CELSIUS
##XYDATA=(XY..XY)
0.00055, 40.0
0.01722, 40.0
0.03388, 40.0
0.05055, 40.0
0.06722, 40.0
0.08388, 39.9
0.10055, 39.9
0.11722, 39.9
0.13388, 39.9
0.15055, 39.9
0.16722, 39.9
0.18388, 39.9
0.20055, 39.9
0.21722, 39.9
0.23388, 39.9
0.25055, 39.9
0.26722, 40.0
0.28388, 40.0
0.30055, 39.9
0.31722, 40.0
0.33388, 40.0
0.35055, 40.0
0.36722, 39.9
0.38388, 40.0
0.40055, 39.9
0.41722, 40.0
0.43388, 40.0
0.45055, 40.0
0.46722, 40.0
0.48388, 40.0
0.50055, 40.0
0.51722, 39.9
0.53388, 40.0
0.55055, 40.0
0.56722, 40.0
0.58388, 39.9
0.60055, 39.9
0.61722, 40.0
0.63388, 40.0
0.65055, 40.0
0.66722, 40.0
0.68388, 40.0
0.70055, 39.9
0.71722, 39.9
0.73388, 39.9
0.75055, 39.9
0.76722, 39.9
0.78388, 39.9
0.80055, 40.0
0.81722, 40.0
0.83388, 39.9
0.85055, 39.9
0.86722, 39.9
0.88388, 39.9
0.90055, 40.0
0.91722, 40.0
0.93388, 39.9
0.95055, 39.9
0.96722, 39.9
0.98388, 40.0
1.00055, 40.0
1.01722, 40.0
1.03388, 40.0
1.05055, 40.0
1.06722, 40.0
1.08388, 40.0
1.10055, 40.0
1.11722, 40.0
1.13388, 40.0
1.15055, 40.0
1.16722, 40.0
1.18388, 40.0
1.20055, 40.0
1.21722, 40.0
1.23388, 40.0
1.25055, 40.0
1.26722, 40.0
1.28388, 40.0
1.30055, 40.0
1.31722, 40.0
1.33388, 40.0
1.35055, 40.0
1.36722, 40.0
1.38388, 40.0
1.40055, 40.0
1.41722, 40.0
1.43388, 40.0
1.45055, 40.0
1.46722, 40.0
1.48388, 40.0
1.50055, 40.0
1.51722, 40.0
1.53388, 40.0
1.55055, 40.0
1.56722, 40.0
1.58388, 40.0
1.60055, 40.0
1.61722, 40.0
1.63388, 40.0
1.65055, 40.0
1.66722, 40.0
1.68388, 40.0
1.70055, 40.0
1.71722, 40.0
1.73388, 40.0
1.75055, 40.0
1.76722, 40.0
1.78388, 40.0
1.80055, 40.0
1.81722, 40.0
1.83388, 40.0
1.85055, 40.0
1.86722, 40.0
1.88388, 40.0
1.90055, 40.0
1.91722, 40.0
1.93388, 40.0
1.95055, 40.0
1.96722, 40.0
1.98388, 40.0
2.00055, 40.0
2.01722, 40.0
2.03388, 40.0
2.05055, 40.0
2.06722, 40.0
2.08388, 40.0
2.10055, 40.0
2.11722, 40.0
2.13388, 40.0
2.15055, 40.0
2.16722, 40.0
2.18388, 40.0
2.20055, 40.0
2.21722, 40.0
2.23388, 40.0
2.25055, 40.0
2.26722, 40.0
2.28388, 40.0
2.30055, 40.0
2.31722, 40.0
2.33388, 40.0
2.35055, 40.0
2.36722, 40.0
2.38388, 40.0
2.40055, 40.0
2.41722, 40.0
2.43388, 40.0
2.45055, 40.0
2.46722, 40.0
2.48388, 40.0
2.50055, 40.0
2.51722, 40.0
2.53388, 40.0
2.55055, 40.0
2.56722, 40.0
2.58388, 40.0
2.60055, 40.0
2.61722, 40.0
2.63388, 40.0
2.65055, 40.0
2.66722, 40.0
2.68388, 40.0
2.70055, 40.0
2.71722, 40.0
2.73388, 40.0
2.75055, 40.0
2.76722, 40.0
2.78388, 40.0
2.80055, 40.0
2.81722, 40.0
2.83388, 40.0
2.85055, 40.0
2.86722, 40.0
2.88388, 40.0
2.90055, 40.0
2.91722, 40.0
2.93388, 40.0
2.95055, 40.0
2.96722, 40.0
2.98388, 40.0
3.00055, 40.0
3.01722, 40.2
3.03388, 40.4
3.05055, 40.7
3.06722, 41.1
3.08388, 41.5
3.10055, 41.8
3.11722, 42.2
3.13388, 42.5
3.15055, 42.8
3.16722, 43.1
3.18388, 43.4
3.20055, 43.7
3.21722, 44.0
3.23388, 44.2
3.25055, 44.5
3.26722, 44.8
3.28388, 45.2
3.30055, 45.5
3.31722, 45.9
3.33388, 46.1
3.35055, 46.5
3.36722, 46.8
3.38388, 47.2
3.40055, 47.5
3.41722, 47.8
3.43388, 48.1
3.45055, 48.5
3.46722, 48.8
3.48388, 49.2
3.50055, 49.5
3.51722, 49.8
3.53388, 50.2
3.55055, 50.5
3.56722, 50.8
3.58388, 51.2
3.60055, 51.5
3.61722, 51.8
3.63388, 52.1
3.65055, 52.5
3.66722, 52.8
3.68388, 53.1
3.70055, 53.4
3.71722, 53.7
3.73388, 54.1
3.75055, 54.4
3.76722, 54.7
3.78388, 55.1
3.80055, 55.4
3.81722, 55.7
3.83388, 56.0
3.85055, 56.4
3.86722, 56.7
3.88388, 57.0
3.90055, 57.3
3.91722, 57.7
3.93388, 58.0
3.95055, 58.4
3.96722, 58.7
3.98388, 59.0
4.00055, 59.4
4.01722, 59.7
4.03388, 60.0
4.05055, 60.3
4.06722, 60.7
4.08388, 61.0
4.10055, 61.3
4.11722, 61.7
4.13388, 62.0
4.15055, 62.3
4.16722, 62.7
4.18388, 63.1
4.20055, 63.4
4.21722, 63.7
4.23388, 64.0
4.25055, 64.3
4.26722, 64.7
4.28388, 65.0
4.30055, 65.4
4.31722, 65.7
4.33388, 66.0
4.35055, 66.3
4.36722, 66.7
4.38388, 67.0
4.40055, 67.3
4.41722, 67.7
4.43388, 68.0
4.45055, 68.3
4.46722, 68.7
4.48388, 69.0
4.50055, 69.3
4.51722, 69.7
4.53388, 70.0
4.55055, 70.3
4.56722, 70.7
4.58388, 71.0
4.60055, 71.3
4.61722, 71.7
4.63388, 72.0
4.65055, 72.4
4.66722, 72.7
4.68388, 73.0
4.70055, 73.4
4.71722, 73.7
4.73388, 74.0
4.75055, 74.4
4.76722, 74.7
4.78388, 75.1
4.80055, 75.4
4.81722, 75.8
4.83388, 76.1
4.85055, 76.4
4.86722, 76.8
4.88388, 77.1
4.90055, 77.5
4.91722, 77.8
4.93388, 78.2
4.95055, 78.5
4.96722, 78.9
4.98388, 79.2
5.00055, 79.5
5.01722, 79.8
5.03388, 80.2
5.05055, 80.5
5.06722, 80.8
5.08388, 81.2
5.10055, 81.5
5.11722, 81.8
5.13388, 82.2
5.15055, 82.6
5.16722, 82.9
5.18388, 83.2
5.20055, 83.5
5.21722, 83.9
5.23388, 84.3
5.25055, 84.6
5.26722, 84.9
5.28388, 85.3
5.30055, 85.6
5.31722, 86.0
5.33388, 86.4
5.35055, 86.7
5.36722, 87.1
5.38388, 87.4
5.40055, 87.7
5.41722, 88.0
5.43388, 88.4
5.45055, 88.7
5.46722, 89.1
5.48388, 89.4
5.50055, 89.7
5.51722, 90.0
5.53388, 90.4
5.55055, 90.7
5.56722, 91.0
5.58388, 91.3
5.60055, 91.7
5.61722, 92.1
5.63388, 92.4
5.65055, 92.7
5.66722, 93.1
5.68388, 93.4
5.70055, 93.7
5.71722, 94.1
5.73388, 94.4
5.75055, 94.7
5.76722, 95.1
5.78388, 95.4
5.80055, 95.8
5.81722, 96.1
5.83388, 96.4
5.85055, 96.7
5.86722, 97.1
5.88388, 97.4
5.90055, 97.8
5.91722, 98.1
5.93388, 98.5
5.95055, 98.8
5.96722, 99.2
5.98388, 99.5
6.00055, 99.9
6.01722, 100.2
6.03388, 100.6
6.05055, 101.0
6.06722, 101.3
6.08388, 101.7
6.10055, 102.0
6.11722, 102.3
6.13388, 102.6
6.15055, 103.0
6.16722, 103.3
6.18388, 103.6
6.20055, 104.0
6.21722, 104.3
6.23388, 104.6
6.25055, 105.0
6.26722, 105.3
6.28388, 105.6
6.30055, 106.0
6.31722, 106.3
6.33388, 106.6
6.35055, 107.0
6.36722, 107.3
6.38388, 107.6
6.40055, 108.0
6.41722, 108.4
6.43388, 108.7
6.45055, 109.1
6.46722, 109.4
6.48388, 109.7
6.50055, 110.1
6.51722, 110.4
6.53388, 110.7
6.55055, 111.0
6.56722, 111.4
6.58388, 111.7
6.60055, 112.0
6.61722, 112.4
6.63388, 112.7
6.65055, 113.1
6.66722, 113.4
6.68388, 113.7
6.70055, 114.1
6.71722, 114.4
6.73388, 114.7
6.75055, 115.0
6.76722, 115.4
6.78388, 115.7
6.80055, 116.0
6.81722, 116.3
6.83388, 116.7
6.85055, 117.0
6.86722, 117.3
6.88388, 117.6
6.90055, 118.0
6.91722, 118.3
6.93388, 118.6
6.95055, 119.0
6.96722, 119.3
6.98388, 119.7
7.00055, 120.0
7.01722, 120.3
7.03388, 120.6
7.05055, 120.9
7.06722, 121.3
7.08388, 121.6
7.10055, 122.0
7.11722, 122.3
7.13388, 122.6
7.15055, 123.0
7.16722, 123.3
7.18388, 123.6
7.20055, 123.9
7.21722, 124.3
7.23388, 124.6
7.25055, 125.0
7.26722, 125.3
7.28388, 125.6
7.30055, 126.0
7.31722, 126.3
7.33388, 126.6
7.35055, 127.0
7.36722, 127.3
7.38388, 127.7
7.40055, 128.0
7.41722, 128.3
7.43388, 128.7
7.45055, 129.0
7.46722, 129.3
7.48388, 129.7
7.50055, 130.0
7.51722, 130.3
7.53388, 130.6
7.55055, 131.0
7.56722, 131.3
7.58388, 131.6
7.60055, 132.0
7.61722, 132.3
7.63388, 132.6
7.65055, 132.9
7.66722, 133.3
7.68388, 133.7
7.70055, 134.0
7.71722, 134.4
7.73388, 134.7
7.75055, 135.0
7.76722, 135.3
7.78388, 135.7
7.80055, 136.0
7.81722, 136.3
7.83388, 136.7
7.85055, 137.0
7.86722, 137.4
7.88388, 137.7
7.90055, 138.0
7.91722, 138.3
7.93388, 138.7
7.95055, 139.0
7.96722, 139.3
7.98388, 139.7
8.00055, 140.0
8.01722, 140.3
8.03388, 140.7
8.05055, 141.0
8.06722, 141.3
8.08388, 141.7
8.10055, 142.0
8.11722, 142.4
8.13388, 142.7
8.15055, 143.0
8.16722, 143.3
8.18388, 143.7
8.20055, 144.0
8.21722, 144.3
8.23388, 144.6
8.25055, 145.0
8.26722, 145.3
8.28388, 145.6
8.30055, 146.0
8.31722, 146.3
8.33388, 146.6
8.35055, 147.0
8.36722, 147.3
8.38388, 147.6
8.40055, 147.9
8.41722, 148.3
8.43388, 148.7
8.45055, 149.0
8.46722, 149.4
8.48388, 149.7
8.50055, 150.0
8.51722, 150.3
8.53388, 150.7
8.55055, 151.0
8.56722, 151.3
8.58388, 151.7
8.60055, 152.0
8.61722, 152.3
8.63388, 152.7
8.65055, 153.0
8.66722, 153.3
8.68388, 153.7
8.70055, 154.0
8.71722, 154.3
8.73388, 154.7
8.75055, 155.0
8.76722, 155.3
8.78388, 155.6
8.80055, 156.0
8.81722, 156.3
8.83388, 156.6
8.85055, 157.0
8.86722, 157.3
8.88388, 157.6
8.90055, 158.0
8.91722, 158.3
8.93388, 158.6
8.95055, 159.0
8.96722, 159.3
8.98388, 159.6
9.00055, 160.0
9.01722, 160.3
9.03388, 160.6
9.05055, 161.0
9.06722, 161.3
9.08388, 161.6
9.10055, 162.0
9.11722, 162.3
9.13388, 162.6
9.15055, 163.0
9.16722, 163.3
9.18388, 163.6
9.20055, 164.0
9.21722, 164.3
9.23388, 164.7
9.25055, 165.0
9.26722, 165.4
9.28388, 165.7
9.30055, 166.0
9.31722, 166.4
9.33388, 166.7
9.35055, 167.0
9.36722, 167.3
9.38388, 167.6
9.40055, 168.0
9.41722, 168.3
9.43388, 168.6
9.45055, 169.0
9.46722, 169.3
9.48388, 169.6
9.50055, 170.0
9.51722, 170.3
9.53388, 170.6
9.55055, 170.9
9.56722, 171.3
9.58388, 171.6
9.60055, 172.0
9.61722, 172.3
9.63388, 172.6
9.65055, 172.9
9.66722, 173.3
9.68388, 173.6
9.70055, 174.0
9.71722, 174.3
9.73388, 174.7
9.75055, 175.0
9.76722, 175.3
9.78388, 175.6
9.80055, 175.9
9.81722, 176.3
9.83388, 176.7
9.85055, 177.0
9.86722, 177.3
9.88388, 177.7
9.90055, 178.0
9.91722, 178.3
9.93388, 178.6
9.95055, 179.0
9.96722, 179.3
9.98388, 179.6
10.00055, 179.9
10.01722, 180.1
10.03388, 180.2
10.05055, 180.1
10.06722, 180.1
10.08388, 180.1
10.10055, 180.1
10.11722, 180.0
10.13388, 180.0
10.15055, 180.0
10.16722, 180.0
10.18388, 180.0
10.20055, 180.0
10.21722, 180.0
10.23388, 180.0
10.25055, 180.1
10.26722, 180.1
10.28388, 180.1
10.30055, 180.1
10.31722, 180.1
10.33388, 180.2
10.35055, 180.2
10.36722, 180.1
10.38388, 180.1
10.40055, 180.1
10.41722, 180.2
10.43388, 180.2
10.45055, 180.1
10.46722, 180.1
10.48388, 180.1
10.50055, 180.1
10.51722, 180.1
10.53388, 180.2
10.55055, 180.2
10.56722, 180.1
10.58388, 180.1
10.60055, 180.1
10.61722, 180.1
10.63388, 180.1
10.65055, 180.1
10.66722, 180.1
10.68388, 180.1
10.70055, 180.1
10.71722, 180.1
10.73388, 180.1
10.75055, 180.1
10.76722, 180.1
10.78388, 180.1
10.80055, 180.1
10.81722, 180.1
10.83388, 180.1
10.85055, 180.1
10.86722, 180.1
10.88388, 180.1
10.90055, 180.1
10.91722, 180.1
10.93388, 180.0
10.95055, 180.1
10.96722, 180.1
10.98388, 180.1
11.00055, 180.1
11.01722, 180.1
11.03388, 180.1
11.05055, 180.1
11.06722, 180.1
11.08388, 180.1
11.10055, 180.1
11.11722, 180.1
11.13388, 180.1
11.15055, 180.1
11.16722, 180.1
11.18388, 180.1
11.20055, 180.1
11.21722, 180.1
11.23388, 180.1
11.25055, 180.1
11.26722, 180.1
11.28388, 180.1
11.30055, 180.1
11.31722, 180.1
11.33388, 180.1
11.35055, 180.1
11.36722, 180.1
11.38388, 180.1
11.40055, 180.1
11.41722, 180.1
11.43388, 180.1
11.45055, 180.1
11.46722, 180.1
11.48388, 180.1
11.50055, 180.1
11.51722, 180.1
11.53388, 180.1
11.55055, 180.1
11.56722, 180.1
11.58388, 180.1
11.60055, 180.1
11.61722, 180.1
11.63388, 180.1
11.65055, 180.1
11.66722, 180.1
11.68388, 180.1
11.70055, 180.1
11.71722, 180.1
11.73388, 180.1
11.75055, 180.1
11.76722, 180.1
11.78388, 180.1
11.80055, 180.1
11.81722, 180.1
11.83388, 180.1
11.85055, 180.1
11.86722, 180.1
11.88388, 180.1
11.90055, 180.1
11.91722, 180.1
11.93388, 180.1
11.95055, 180.1
11.96722, 180.1
11.98388, 180.0
##END=$$ End of the data block


`;

export default gcJcamp3;
